
<li>
    <i (click)="showUrls()" style="cursor: pointer; color: #337ab7;" class="fa fa-plus-square margin-right-5"></i>
    <a [routerLink]="['/videocoursescontentview', entry.Information.Alias]"  >{{entry.Information.Title}}</a>                                                   
</li>

<div [ngStyle]="{display : showChildren()}">
    <ul>
        <li *ngFor="let aModule of entry.ContentEntries">
            <a [routerLink]="['/videocoursesmoduleview', aModule.Information.Alias]"  >{{aModule.Information.Title}}</a>                                                   
        </li>
    </ul>
</div>



